import { Formik } from 'formik';
import { FC } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import * as Yup from 'yup';
import LabelRequired from './LabelRequired';
import TextField from './TextField';

interface Props {
	show: boolean;
	onCloseClick?: () => void;
	onYesClick: (values: any) => void;
	onCancelClick?: () => void;
	title?: string;
	message?: string;
	yes?: string;
	cancel?: string;
	close?: string;
	className?: string;
	name: string;
	label: string;
}

const ConfirmReasonDialog: FC<Props> = ({
	show,
	onCloseClick,
	onYesClick,
	onCancelClick,
	title,
	yes,
	cancel,
	close,
	className,
	name,
	label,
}) => {
	const validationSchema = Yup.object({
		[name]: Yup.string().nullable().required('Bắt buộc nhập'),
	});

	return (
		<Modal show={show} onHide={onCloseClick} centered className={className}>
			<Modal.Header className="header-modal" closeButton>
				<Modal.Title>{title}</Modal.Title>
			</Modal.Header>

			<Formik
				initialValues={{
					[name]: '',
				}}
				validationSchema={validationSchema}
				onSubmit={(values) => onYesClick(values)}
			>
				{({ submitForm }) => (
					<Form>
						<Modal.Body className="p-4">
							<Row>
								<Col xs={12}>
									<div>
										<LabelRequired label={label} isRequired />
										<TextField
											name={name}
											as="textarea"
											className="spaces h-110"
										/>
									</div>
								</Col>
							</Row>
						</Modal.Body>
						<Modal.Footer className="d-flex justify-content-end p-2">
							{cancel && (
								<Button
									className="spaces btn-secondary px-16"
									onClick={onCancelClick}
								>
									{cancel}
								</Button>
							)}
							{close && (
								<Button className="btn-danger spaces px-16" onClick={onCloseClick}>
									{close}
								</Button>
							)}
							{yes && (
								<Button className="btn-fill spaces px-16" onClick={submitForm}>
									{yes}
								</Button>
							)}
						</Modal.Footer>
					</Form>
				)}
			</Formik>
		</Modal>
	);
};

export { ConfirmReasonDialog };
